import { t } from "i18next";
import CountUp from "react-countup";

import Warning from "@/assets/icons/info.svg?react";
import { getDaysRemaining } from "@/utils/date";

import { ReMintComponentsProps, ReMintVariant } from "./interface";
import { baseReMintStyles, reMintWithExpiryAndUpdateStyles, reMintWithExpiryStyles } from "./styles";
import { getReMintVariant } from "./utils";
import { Button } from "../Button";

export const ReMintWithExpiry = ({
  reMint,
  reMinting,
  currentScore,
  expirationDate,
  newScore = 0,
}: ReMintComponentsProps) => {
  const variant = getReMintVariant(currentScore, newScore, expirationDate);

  switch (variant) {
    case ReMintVariant.BaseReMint:
      return (
        <baseReMintStyles.Container>
          <baseReMintStyles.Text>
            <span>{t("ReMint.NewScore")}</span>
            <baseReMintStyles.ScoreAmount $score={newScore}>
              <CountUp start={currentScore} end={newScore} delay={1} duration={2} />
              <span>/100</span>
            </baseReMintStyles.ScoreAmount>
          </baseReMintStyles.Text>
          <Button name="ReMint" handler={reMint} loading={reMinting} />
        </baseReMintStyles.Container>
      );

    case ReMintVariant.ReMintWithExpired:
      return (
        <reMintWithExpiryStyles.Container $isExpired>
          <Warning />
          <reMintWithExpiryStyles.Text>{t("ReMint.ScoreExpired")}</reMintWithExpiryStyles.Text>
          <Button name="ReMint" handler={reMint} loading={reMinting} />
        </reMintWithExpiryStyles.Container>
      );

    case ReMintVariant.ReMintWithUpcomingExpiry: {
      if (!expirationDate) return null;
      return (
        <reMintWithExpiryStyles.Container>
          <Warning />
          <reMintWithExpiryStyles.Text>
            {t("ReMint.ScoreUpcomingExpiry", { days: getDaysRemaining(expirationDate) })}
          </reMintWithExpiryStyles.Text>
          <Button name="ReMint" handler={reMint} loading={reMinting} />
        </reMintWithExpiryStyles.Container>
      );
    }

    case ReMintVariant.ReMintWithExpiredAndUpdate: {
      const points = currentScore - newScore;
      return (
        <reMintWithExpiryAndUpdateStyles.Container $isExpired>
          <reMintWithExpiryAndUpdateStyles.Header>
            <Warning />
            <reMintWithExpiryAndUpdateStyles.Text>
              <span>{t("ReMint.ScoreExpired")}</span>
              <span>{t("ReMint.ScoreWillBeDecreased", { points })}</span>
            </reMintWithExpiryAndUpdateStyles.Text>
          </reMintWithExpiryAndUpdateStyles.Header>
          <Button name="ReMint" handler={reMint} loading={reMinting} />
        </reMintWithExpiryAndUpdateStyles.Container>
      );
    }

    case ReMintVariant.ReMintWithUpcomingExpiryAndUpdated: {
      if (!expirationDate) return null;
      const points = currentScore - newScore;
      return (
        <reMintWithExpiryAndUpdateStyles.Container>
          <reMintWithExpiryAndUpdateStyles.Header>
            <Warning />
            <reMintWithExpiryAndUpdateStyles.Text>
              <span>{t("ReMint.ScoreUpcomingExpiry", { days: getDaysRemaining(expirationDate) })}</span>
              <span>{t("ReMint.ScoreWillBeDecreased", { points })}</span>
            </reMintWithExpiryAndUpdateStyles.Text>
          </reMintWithExpiryAndUpdateStyles.Header>
          <Button name="ReMint" handler={reMint} loading={reMinting} />
        </reMintWithExpiryAndUpdateStyles.Container>
      );
    }

    default:
      return null;
  }
};
